import React from 'react'
import RadioButtons from '../../../../components/common/inputs/RadioButtons'
import { requiredAndNumberRules, requiredRule } from '../helpers/ValidationRules'
import { StepProps } from '../types/RoiCalculatorTypes'
import NumberField from './NumberField'
import PriceField from './PriceField'
import I18n from '../../../../helpers/I18n'

const ManualProcessFields: React.FC<StepProps> = ({
  formControl,
  watchedFields,
  exchangeRate,
  design,
}) => {
  const validateManualProcess = {
    required: value =>
      parseInt(value) >= 0 || (value === '' && !watchedFields?.automatedProcess)
        ? true
        : I18n.t('views.roi_calculator.form.errors.manual_process'),
    positive: value =>
      parseInt(value) >= 0 || value === ''
        ? true
        : I18n.t('views.roi_calculator.form.errors.positive'),
  }

  return (
    <>
      <RadioButtons
        label={I18n.t('views.roi_calculator.form.labels.hours_per_shift')}
        {...formControl.register('hoursPerShift', requiredRule)}
        errorMessage={formControl.formState.errors.hoursPerShift?.message?.toString()}
        options={[4, 6, 8, 10, 12]}
        infoTip={I18n.t('views.roi_calculator.form.tooltips.hours_per_shift')}
      />
      <RadioButtons
        label={I18n.t('views.roi_calculator.form.labels.shifts_per_day')}
        {...formControl.register('shiftsPerDay', requiredRule)}
        errorMessage={formControl.formState.errors.shiftsPerDay?.message?.toString()}
        options={[1, 1.5, 2, 3]}
        infoTip={I18n.t('views.roi_calculator.form.tooltips.shifts_per_day')}
      />
      <NumberField
        name="numberOfWorkersPerShift"
        formControl={formControl}
        label={[
          I18n.t(
            "views.roi_calculator.form.labels.number_of_workers_per_shift",
          ),
        ]}
        infoTip={I18n.t(
          "views.roi_calculator.form.tooltips.number_of_workers_per_shift",
        )}
        decimalScale={2}
        rules={requiredRule}
      />
      <RadioButtons
        label={I18n.t('views.roi_calculator.form.labels.days_per_week')}
        {...formControl.register('workDaysPerWeek', requiredRule)}
        errorMessage={formControl.formState.errors.workDaysPerWeek?.message?.toString()}
        options={[4, 5, 6, 7]}
        infoTip={I18n.t('views.roi_calculator.form.tooltips.days_per_week')}
      />
      <PriceField
        name='labourRate'
        formControl={formControl}
        rules={requiredAndNumberRules}
        label={I18n.t('views.roi_calculator.form.labels.labour_rate')}
        infoTip={I18n.t('views.roi_calculator.form.tooltips.labour_rate')}
        currencyUnit={design?.currency_code || exchangeRate.currency_code}
        currencySymbol={design?.currency_symbol || exchangeRate.currency_symbol}
        endAdornment={`${design?.currency_code || exchangeRate.currency_code}/${I18n.t(
          'datetime.units.hour'
        )}`}
        decimalScale={2}
      />
      <RadioButtons
        label={I18n.t('views.roi_calculator.form.labels.worker_efficiency')}
        {...formControl.register('estimatedWorkerEfficiency', requiredRule)}
        errorMessage={formControl.formState.errors.estimatedWorkerEfficiency?.message?.toString()}
        options={[
          { value: 0.6, label: '60%' },
          { value: 0.7, label: '70%' },
          { value: 0.8, label: '80%' },
          { value: 0.9, label: '90%' },
          { value: 1, label: '100%' },
        ]}
        infoTip={I18n.t('views.roi_calculator.form.tooltips.worker_efficiency')}
      />
      <NumberField
        name='manualProcess'
        formControl={formControl}
        label={[
          I18n.t('views.roi_calculator.form.labels.manual_process'),
          <em className='roi-calculator-optional' key='manual-process'>
            ({I18n.t('views.roi_calculator.form.labels.optional')})
          </em>,
        ]}
        infoTip={I18n.t('views.roi_calculator.form.tooltips.manual_process')}
        endAdornment={I18n.t('datetime.units.seconds')}
        decimalScale={2}
        rules={{ validate: validateManualProcess }}
      />
    </>
  )
}

export default ManualProcessFields
